import { Controller } from "@hotwired/stimulus"

// Highlights the active conversation in the list, keeping it in sync when items
// are streamed in (reordered) via Turbo.
export default class extends Controller {
  static targets = ["item"]
  static classes = ["active", "inactive"]
  static values = { activeId: String }

  itemTargetConnected(item) {
    this.paint(item)
  }

  select(event) {
    this.activeIdValue = event.currentTarget.dataset.conversationId
    this.itemTargets.forEach((item) => this.paint(item))
  }

  paint(item) {
    const isActive = item.dataset.conversationId === this.activeIdValue
    item.classList.remove(...this.activeClasses, ...this.inactiveClasses)
    item.classList.add(...(isActive ? this.activeClasses : this.inactiveClasses))
  }
}
